function toggleInternInfo(id) {
  $('.intern__item-container[data-id="' + id + '"]').toggleClass('-active');
  const isActive = $('.intern__item-container[data-id="' + id + '"]').hasClass(
    '-active'
  );
  $('.intern__item-container[data-id="' + id + '"] .intern__item-content-container')[
    isActive ? 'slideDown' : 'slideUp'
  ]({
    queue: false,
    duration: 250
  });
}
